import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';

export const isNavPanelOpenStateSegment = stateSegmentWithReset(false);

isNavPanelOpenStateSegment.debugLabel = 'isNavPanelOpenStateSegment';
